export default __webpack_public_path__ + "static/media/user.9e25dbf0.svg";